import React from 'react'
import MainCategory from './MainCategory';
import { useFilters } from './FilterContext';

function MobileFilter(props) {
  const { selectedFilters, pendingFiltersList, isPendingActive, removeFilter, removePendingFilter, clearAllFilters, clearPendingFilters, loader } = useFilters();
  
  const tags = isPendingActive ? pendingFiltersList : selectedFilters;
  const onRemove = (category, label) => {
    if (isPendingActive) {
      removePendingFilter(category, label);
    } else {
      removeFilter(category, label);
    }
  };

  const onClearAll = () => {
    if (isPendingActive) {
      clearPendingFilters();
    } else {
      clearAllFilters();
    }
  };

  return (
    <>
      <h2 className="filter-title">Filters</h2>

      {tags.length > 0 && (
        <div className="selected-filters">
          <h4>Selected Filters:</h4>
          <div className="filter-tags">
            {tags.map(({ category, label, value }) => (
              <span key={`${category}-${label}`} className="filter-tag">
                
                <button
                  onClick={() => onRemove(category, label)}
                  className="remove-btn"
                >
                  {value}
                </button>
              </span>
            ))}
          </div>
          <button onClick={onClearAll} className="clear-all-btn">
            Clear All Filters
          </button>
        </div>
      )}

      {props.sidebarData.map((main, idx) => (
        <MainCategory key={main.title} main={main} isLast={idx === props.sidebarData.length - 1} />
      ))}

      {/* Apply/Cancel buttons for mobile */}
      <div className="mobile-filter-actions">
        <button 
          className="cancel-btn" 
          onClick={props.onCancel}
          disabled={loader}
        >
          Cancel
        </button>
        <button 
          className="apply-btn" 
          onClick={props.onApply}
          disabled={loader}
        >
          {loader ? 'Applying...' : 'Apply Filters'}
        </button>
      </div>
    </>
  )
}

export default MobileFilter;
